import { WithdrawPanelCSS } from './WithdrawPanelCSS.styled'
import { WithdrawPad } from 'components/Organisms/walletPage/WalletOperation/WithdrawPanel/WithdrawPad'

export const WithdrawPanel = () => {
  return (
    <WithdrawPanelCSS>
      <div className='withdraw_sections_wrapper'>
        <div className='wallet_tabs_panel' id='withdraw_panel'>
          <WithdrawPad />
        </div>
      </div>
    </WithdrawPanelCSS>
  )
}
